import { Forward } from 'lucide-react';
import React from 'react';
import IconForwardThinking from '../icons/IconForwardThinking';
import IconDrivenCoachable from '../icons/IconDrivenCoachable';
import IconStrongRelationshipBuilder from '../icons/IconStrongRelationshipBuilder';
import IconLeadershipSkills from '../icons/IconLeadershipSkills';
import IconPassionForSteam from '../icons/IconPassionForSteam';

const LookingForSection = ({toSection,section}) => {
  // Custom SVG icons
  
  const DrivenIcon = () => (
    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="8" y="8" width="24" height="24" rx="2" stroke="white" strokeWidth="2"/>
      <path d="M14 20L18 24L26 16" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );

  const RelationshipIcon = () => (
    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="20" cy="12" r="4" stroke="white" strokeWidth="2"/>
      <circle cx="10" cy="24" r="3" stroke="white" strokeWidth="2"/>
      <circle cx="30" cy="24" r="3" stroke="white" strokeWidth="2"/>
      <path d="M20 16V32" stroke="white" strokeWidth="2" strokeLinecap="round"/>
      <path d="M10 27V32" stroke="white" strokeWidth="2" strokeLinecap="round"/>
      <path d="M30 27V32" stroke="white" strokeWidth="2" strokeLinecap="round"/>
      <path d="M16 32H24" stroke="white" strokeWidth="2" strokeLinecap="round"/>
    </svg>
  );

  const LeadershipIcon = () => (
    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M12 32H28" stroke="white" strokeWidth="2" strokeLinecap="round"/>
      <path d="M20 8L28 16L20 24L12 16L20 8Z" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M20 24V32" stroke="white" strokeWidth="2" strokeLinecap="round"/>
    </svg>
  );

  const PassionIcon = () => (
    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M20 32C26.6274 32 32 26.6274 32 20C32 13.3726 26.6274 8 20 8C13.3726 8 8 13.3726 8 20C8 26.6274 13.3726 32 20 32Z" stroke="white" strokeWidth="2"/>
      <path d="M20 16V24" stroke="white" strokeWidth="2" strokeLinecap="round"/>
      <path d="M16 20H24" stroke="white" strokeWidth="2" strokeLinecap="round"/>
    </svg>
  );

  const qualities = [
    {
      title: "Forward-Thinking:",
      description: "You're innovative and proactive, always looking for ways to improve and inspire.",
      Icon: <IconForwardThinking />,
      color: "#A064B4", // Pink
      bgColor: "rgba(255, 18, 120, 0.1)" // Light pink background
    },
    {
      title: "Driven & Coachable:",
      description: "Motivated to succeed with the humility to learn and adapt.",
      Icon: <IconDrivenCoachable />,
      color: "#F18917", // Blue
      bgColor: "rgba(22, 120, 242, 0.1)" // Light blue background
    },
    {
      title: "Strong Relationship Builder:",
      description: "Skilled at connecting with children, parents, and the community, creating a network of trust and engagement.",
      Icon:  <IconStrongRelationshipBuilder />,
      color: "#0088CE", // Dark Blue
      bgColor: "rgba(0, 33, 71, 0.1)" // Light navy background
    },
    {
      title: "Leadership Skills:",
      description: "Able to guide and inspire a team, with a strong commitment to quality education.",
      Icon: <IconLeadershipSkills />,
      color: "#67B437", // Orange
      bgColor: "rgba(255, 107, 44, 0.1)" // Light orange background
    },
    {
      title: "Passion for STEAM:",
      description: "You genuinely care about science, technology, engineering, arts, and math and are eager to share that excitement with young minds.",
      Icon: <IconPassionForSteam />,
      color: "#CD2628", // Light Blue
      bgColor: "rgba(122, 166, 191, 0.1)" // Light blue background
    }
  ];

  return (
    <div className="bg-white py-20" id={section} >
      <div className="container mx-auto px-4">
        <h2 className="font-['Grandstander'] text-4xl font-extrabold text-center text-[#002147] mb-4">
          Who are we looking for?
        </h2>
         
        <p className="text-center text-[#002147] mb-12 font-['Lexend']">
        We’re seeking passionate, community oriented individuals who believe in the power of education and are excited about bringing Tinker Labs to their area. You don’t need teaching experience, just a desire to teach. Tinker Labs provides all the training and resources you’ll need to succeed.
        </p>

        {/* Icons and Descriptions */}
        <div className="grid md:grid-cols-2 lg:grid-cols-5 gap-6 mx-auto">
          {qualities.map((quality, index) => (
            <div 
              key={index} 
              className="flex flex-col items-center bg-[#fff] p-6 rounded-xl"
               
            >
              <div 
                className="w-16 h-16 rounded-full mb-4 flex items-center justify-center"
                style={{ backgroundColor: quality.color }}
              >
                {quality.Icon }
              </div>
              <div className="text-center">
                <h4 className="font-['Lexend'] font-bold text-[#002147] mb-2">
                  {quality.title}
                </h4>
                <p className="font-['Lexend']" style={{color:quality.color}}>
                  {quality.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default LookingForSection;